import React from "react"
import { HeaderContainer } from "./style"

import Logo from "../../assets/logo-ico.png"

import { useAuth } from "../../hooks/auth"
import { useHistory } from "react-router-dom"

const resumeName = (name: string) => {
  const stopWords = ["de", "da", "do", "dos", "das", "e"]

  const names = name
    .split(" ")
    .filter((n) => !stopWords.includes(n.toLowerCase()))

  return names.slice(0, 2).join(" ")
}

const Header: React.FC = () => {
  const { user } = useAuth()
  const history = useHistory()

  return (
    <HeaderContainer>
      <img
        src={Logo}
        alt="logo"
        onClick={() => {
          history.push("/dashboard")
        }}
      />

      <p>
        Bem Vindo(a), <a href="/profile">{resumeName(user.name)}</a>
      </p>
    </HeaderContainer>
  )
}

export default Header
